import React, { PureComponent, FunctionComponent } from "react";
import { IRepertoireStateKeys } from "../../types/IRepertoireStateKeys";
import { EMPTY_STRING_VALUE, FROM_DATE_SEARCH_USAGES_STATE_KEY, REPERTOIRE_PAGE_FORM_ITEM_SIZE, TO_DATE_SEARCH_USAGES_STATE_KEY } from "../../Consts";
import { connect } from "react-redux";
import IAppState from "../../../redux/types/IAppState";
import { DatePicker } from "antd";
import dayjs from 'dayjs';
import fr_FR from "antd/lib/date-picker/locale/fr_FR";
import en_GB from "antd/lib/date-picker/locale/en_GB";

export interface IDateDataInputProps {
    label: string;
    value: string;
    changeData: (
        value: string | boolean,
        fieldName: IRepertoireStateKeys,
        index?: number
    ) => void;
    fieldName: IRepertoireStateKeys;
    readOnly?: boolean;
    isHidden: boolean;
    isMandatory?: boolean;
    customerDatePreference?: string;
    showTime?: boolean;
    className?: string;
}

const SizedDateDataInput: FunctionComponent<IDateDataInputProps> = (props: IDateDataInputProps) => {

    if (props.isHidden)
        return null;
    return <div className={`${props.className ? props.className : REPERTOIRE_PAGE_FORM_ITEM_SIZE} datePickerSize`} >
        <DateDataInput {...props} />
    </div>
}

interface DateDataInputState {
    panelValue: any;
}

class DateDataInput extends PureComponent<
    IDateDataInputProps,
    DateDataInputState
    > {
    constructor(props: IDateDataInputProps) {
        super(props);
        this.state = {
            panelValue: props.value ? dayjs(props.value) : dayjs(),
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value) {
            this.setState({ panelValue: dayjs(this.props.value) });
        }
    }

    handlePanelChange = (date) => {
        if (date && dayjs.isDayjs(date) && date.isValid()) {
            this.setState({ panelValue: date });
        }
    };

    handleOpenChange = (open) => {
        if (open) {
            this.setState({
                panelValue: this.props.value ? dayjs(this.props.value) : dayjs(),
            });
        }
    };

    render() {
        const { label, changeData, fieldName, readOnly, isMandatory, showTime } = this.props;

        const standardDateForProcessing = showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
        const EUROPEAN_DATE_FORMAT = showTime ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY";
        const preferenceDateFormat = this.props.customerDatePreference
            ? showTime
                ? this.props.customerDatePreference.concat(" HH:mm:ss")
                : this.props.customerDatePreference
            : EUROPEAN_DATE_FORMAT;

        const handleDateChange = (date) => {
            if(date) {
                changeData(date.format(standardDateForProcessing), fieldName)
                return;
            }
            changeData(undefined, fieldName)
        }

        const language = () => {
            const lang = JSON.parse(localStorage.getItem('userLanguagePreferences'));
            switch (lang) {
                case 'fr':
                    return fr_FR;
                case 'en-GB':
                default:
                    return en_GB;
            }
        };

        const MAX_DATE = dayjs('9999-12-31', 'YYYY-MM-DD');

        return (
            <div className={'flexColumn'} style={{
                marginBottom: fieldName === "airDate" || fieldName === "dateOfRevision" || fieldName === "dateOfSubmission" ? "15px": fieldName === FROM_DATE_SEARCH_USAGES_STATE_KEY || fieldName === TO_DATE_SEARCH_USAGES_STATE_KEY ? "20px" : null
            }} >
                {label ? <label className={EMPTY_STRING_VALUE.concat(isMandatory ? " isMandatory " : "", readOnly ? " disabledItem " : "")}>{label}</label> : null}
                <DatePicker
                    showTime={showTime ? { format: "HH:mm:ss" } : undefined}
                    value={this.props.value ? dayjs(this.props.value) : undefined}
                    onChange={handleDateChange}
                    pickerValue={this.state.panelValue}
                    onPanelChange={this.handlePanelChange}
                    onOpenChange={this.handleOpenChange}
                    disabled={readOnly}
                    size="large"
                    format={preferenceDateFormat}
                    locale={language()}
                    disabledDate={(current) =>
                        current && current.isAfter(MAX_DATE, 'day')}
                />
            </div>
        );
    }
}

export default connect((state: IAppState) => {
    return ({
        customerDatePreference: state.account.customerDate,
        customerTimeZonePreference: state.account.customerTimeZone
    })
})(SizedDateDataInput);